import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '#/modules/commonComponents/tabs';
import PageShell from '#/modules/infra/layout/PageShell';
import StocktakeComparisonPage from '#/modules/imsMgmt/receipts/stocktake/pages/StocktakeComparisonPage';
import StocktakeListPage from '#/modules/imsMgmt/receipts/stocktake/pages/StocktakeListPage';

const STOCKTAKE_TAB = {
  LIST: 'list',
  COMPARISON: 'comparison',
};

function resolveStocktakeTab(raw) {
  if (raw === STOCKTAKE_TAB.COMPARISON) {
    return STOCKTAKE_TAB.COMPARISON;
  }
  return STOCKTAKE_TAB.LIST;
}

/**
 * 盤點管理單頁殼：Tabs（列表／比對）＋ `?tab=`。
 */
const StocktakeShellPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = useMemo(
    () => resolveStocktakeTab(searchParams.get('tab')),
    [searchParams],
  );

  function handleTabChange(nextTab) {
    const resolved = resolveStocktakeTab(nextTab);
    setSearchParams({ tab: resolved }, { replace: true });
  }

  return (
    <PageShell variant="listWithSide">
      <div className="layout-shell__body min-h-0">
        <Tabs
          value={tab}
          onValueChange={handleTabChange}
          className="flex min-h-0 flex-1 flex-col gap-0"
        >
          <div className="flex shrink-0 flex-wrap items-start gap-2">
            <h1 className="page_title shrink-0">
              <span className="border-l-5 border-primary-400 pl-2.5">盤點管理</span>
            </h1>
            <TabsList className="shrink-0 flex-wrap justify-start bg-slate-200 p-1">
              <TabsTrigger value={STOCKTAKE_TAB.LIST}>列表</TabsTrigger>
              <TabsTrigger value={STOCKTAKE_TAB.COMPARISON}>比對</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent
            value={STOCKTAKE_TAB.LIST}
            className="mt-0 flex min-h-0 flex-1 flex-col outline-none"
          >
            <StocktakeListPage />
          </TabsContent>
          <TabsContent
            value={STOCKTAKE_TAB.COMPARISON}
            className="mt-0 flex min-h-0 flex-1 flex-col outline-none"
          >
            <StocktakeComparisonPage />
          </TabsContent>
        </Tabs>
      </div>
    </PageShell>
  );
};

export default StocktakeShellPage;
